import { ReactComponent as HrvatskiFlagIcon } from '../px-hrvatski.svg';

export default HrvatskiFlagIcon;
